import type { IFilter } from '@models/Filter'
import { endOfDay, startOfDay } from '@util/date-util'

import { apiClient } from '../../../gateways/api'
import type {
  SubprocessenSearch,
  SubprocessenSearchFilters,
} from '../types/SubprocessenSearch'

export { initialState, createFilters, searchSubprocessen }

const AANSLUITING_PROJECT_TYPES = ['Aanvraag']

const initialState: SubprocessenSearch = {
  data: { count: 0, skip: 0, limit: 25, items: [] },
  query: {
    filters: {
      type: [],
      status: [],
      gebied: [],
      assignedTo: [],
      labels: [],
      fromGeplandeUitvoeringsdatum: null,
      toGeplandeUitvoeringsdatum: null,
      fromDate: null,
      toDate: null,
      myList: false,
      kpi: '',
    },
    sort: { sortBy: 'created.date', sortDirection: 'desc' },
    page: { skip: 0, limit: 25 },
  },
}

const createFilters = ({
  gebied,
  type,
  assignedTo,
  labels,
  toDate,
  fromDate,
  fromGeplandeUitvoeringsdatum,
  toGeplandeUitvoeringsdatum,
  status,
  myList,
  kpi,
}: SubprocessenSearchFilters) => {
  const filters: IFilter[] = [
    { name: 'isActive', value: true, operator: 'eq' },
    {
      name: 'entity.projecttype',
      value: AANSLUITING_PROJECT_TYPES,
      operator: 'in',
    },
  ]

  if (status && status.length > 0) {
    filters.push({
      name: 'status',
      value: status.map(({ code }) => code),
      operator: 'in',
    })
  } else {
    filters.push({
      name: 'isOpen',
      value: true,
      operator: 'eq',
    })
  }

  if (type && type.length > 0)
    filters.push({
      name: 'type',
      value: type.map(({ code }) => code),
      operator: 'in',
    })

  if (gebied && gebied.length > 0)
    filters.push({
      name: 'entity.gebiedscode',
      value: gebied.map(({ code }) => code),
      operator: 'in',
    })
  if (assignedTo && assignedTo.length > 0)
    filters.push({
      name: 'assignedTo',
      value: assignedTo.map(({ label }) => label),
      operator: 'in',
    })
  if (labels && labels.length > 0)
    filters.push({
      name: 'labels',
      value: labels.map(({ code }) => code),
      operator: 'in',
    })
  if (fromDate)
    filters.push({
      name: 'dueDate',
      value: startOfDay(fromDate),
      operator: 'gte',
    })
  if (toDate)
    filters.push({ name: 'dueDate', value: endOfDay(toDate), operator: 'lte' })

  if (fromGeplandeUitvoeringsdatum) {
    filters.push({
      name: 'geplandeUitvoeringsdatum',
      value: startOfDay(fromGeplandeUitvoeringsdatum),
      operator: 'gte',
    })
  }
  if (toGeplandeUitvoeringsdatum) {
    filters.push({
      name: 'geplandeUitvoeringsdatum',
      value: endOfDay(toGeplandeUitvoeringsdatum),
      operator: 'lte',
    })
  }

  if (myList) {
    filters.push({ name: 'my-list', value: true, operator: 'eq' })
  }

  if (kpi) {
    filters.push({ name: 'kpi', value: kpi, operator: 'eq' })
  }

  return filters
}

const searchSubprocessen = async ({
  query,
}: {
  query: SubprocessenSearch['query']
}): Promise<SubprocessenSearch['data']> => {
  const { filters, page, sort } = query

  const { data } = await apiClient({
    url: '/rest/subproces/search',
    method: 'POST',
    data: { filters: createFilters(filters), ...page, ...sort },
  })

  return data
}
